/**
 * App.jsx
 *
 * Configuration complète de l'application avec :
 * - Ant Design + dark mode
 * - AuthProvider
 * - ThemeProvider
 * - Routes
 */

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider, Layout } from "antd";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { getThemeConfig } from "./utils/theme";

// Composants
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import TodaySalesPage from "./pages/TodaySalesPage";
import CardDetailPage from "./pages/CardDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import FavoritesPage from "./pages/FavoritesPage";
import SavedSearchesPage from "./pages/SavedSearchPage";
import AlertsPage from "./pages/AlertsPage";
import SettingsPage from "./pages/SettingsPage";

const { Content } = Layout;

/**
 * AppContent - Contenu de l'app avec thème
 */
function AppContent() {
    const { isDarkMode } = useTheme();
    const themeConfig = getThemeConfig(isDarkMode);

    return (
        <ConfigProvider theme={themeConfig}>
            <Layout style={{ minHeight: "100vh" }}>
                <Navbar />
                <Content>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/search" element={<SearchPage />} />
                        <Route path="/today-sales" element={<TodaySalesPage />} />
                        <Route path="/cards/:id" element={<CardDetailPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/favorites" element={<FavoritesPage />} />
                        <Route path="/settings" element={<SettingsPage />} />
                        <Route path="/saved-searches" element={<SavedSearchesPage />} />
                        <Route path="/alerts/:searchId" element={<AlertsPage />} />
                    </Routes>
                </Content>
                <Footer />
            </Layout>
        </ConfigProvider>
    );
}

/**
 * App - Wrapper avec providers
 */
export default function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <Router>
                    <AppContent />
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}